export const ButtonState = Object.freeze({
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    Loading: 'Loading',
    On: 'On',
    Off: 'Off',
});

export class UIConfig {
    constructor(obj) {
        this.id = null;
        this.value = null;
        this.tabindex = 0;
        this.qaClass = '';

        if (obj && typeof obj === 'object') {
            this.overrideValues(obj);
        }
    }

    overrideValues(obj) {
        if (typeof obj === 'object') {
            for (let key in obj) {
                if (this.hasOwnProperty(key)) {
                    this[key] = obj[key];
                }
            }
        }
    }
}

export class InputConfig extends UIConfig {
    constructor(obj) {
        super();

        this.type = 'text';

        this.overrideValues(obj);
    }
}

export default class ButtonConfig extends UIConfig {
    constructor(obj) {
        super();

        this.type = null;
        this.styleClass = '';
        this.href = '';
        this.event = null;
        this.displayText = '';
        this.ariaLabel = '';

        this.overrideValues(obj);

        if (!this.displayTexts) {
            this.setDisplayTexts(this.displayText);
        }
    }

    setDisplayTexts(enabled, loading, disabled) {
        this.displayText = enabled;

        this.displayTexts = {
            [ButtonState.Enabled]: enabled,
            [ButtonState.Loading]: loading,
            [ButtonState.Disabled]: disabled,
        };
    }
}

export class ToggleUIConfig extends UIConfig {
    constructor(obj) {
        super();

        this.displayTexts = {};

        this.overrideValues(obj);
    }

    setDisplayTexts(labelOn, labelOff) {
        this.displayTexts = {
            [ButtonState.On]: labelOn,
            [ButtonState.Off]: labelOff,
        };
    }
}
